module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#E6F0F2"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "margin-top": "30px",
      "min-width": "730px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入报告/证书编号",
      "size": "large"
    },
    model: {
      value: (_vm.reportCodeSeach),
      callback: function($$v) {
        _vm.reportCodeSeach = $$v
      },
      expression: "reportCodeSeach"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("报告/证书编号:")])], 2), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "39%"
    },
    attrs: {
      "placeholder": "请输入验证码",
      "size": "large"
    },
    model: {
      value: (_vm.checkCodeSeach),
      callback: function($$v) {
        _vm.checkCodeSeach = $$v
      },
      expression: "checkCodeSeach"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("验证码:")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "color": "#08c",
      "font-weight": "bold"
    },
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.loadData()
      }
    },
    slot: "append"
  }, [_vm._v("查询/Search")])], 2)], 1), _vm._v(" "), (!_vm.seachShow) ? _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "border": "1px dashed #000",
      "margin-top": "40px",
      "min-width": "730px"
    },
    attrs: {
      "id": "tableID"
    }
  }, [_c('div', [_c('table', {
    staticStyle: {
      "width": "100%",
      "margin-left": "0%",
      "margin-top": "2%"
    },
    attrs: {
      "border": "0"
    }
  }, [(_vm.data.ReportCode != '' && _vm.data.ReportCode != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("报告/证书编号 ：")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v(_vm._s(_vm.data.ReportCode))])]) : _vm._e(), _vm._v(" "), (_vm.data.ReportType != '' && _vm.data.ReportType != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("报告类型 ：")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v("  " + _vm._s(_vm.data.ReportType))])]) : _vm._e(), _vm._v(" "), (_vm.data.CustomerName != '' && _vm.data.CustomerName != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("客户名称 ： ")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v(" " + _vm._s(_vm.data.CustomerName) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.data.UnitAddress != '' && _vm.data.UnitAddress != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("单位地址 ： ")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v("  " + _vm._s(_vm.data.UnitAddress))])]) : _vm._e(), _vm._v(" "), (_vm.data.SampleName != '' && _vm.data.SampleName != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("样品名称： ")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v(" " + _vm._s(_vm.data.SampleName))])]) : _vm._e(), _vm._v(" "), (_vm.data.FuselageNumber != '' && _vm.data.FuselageNumber != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("机身/管理号：")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v(_vm._s(_vm.data.FuselageNumber))])]) : _vm._e(), _vm._v(" "), (_vm.data.SampleCode != '' && _vm.data.SampleCode != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("样品型号 ： ")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v("  " + _vm._s(_vm.data.SampleCode))])]) : _vm._e(), _vm._v(" "), (_vm.data.TestBasis != '' && _vm.data.TestBasis != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("检测依据 ：")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v("  " + _vm._s(_vm.data.TestBasis) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.data.Conclusion != '' && _vm.data.Conclusion != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("结论     ： ")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v("  " + _vm._s(_vm.data.Conclusion))])]) : _vm._e(), _vm._v(" "), (_vm.data.Reviewer != '' && _vm.data.Reviewer != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("审核人： ")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v(" " + _vm._s(_vm.data.Reviewer))])]) : _vm._e(), _vm._v(" "), (_vm.data.Issuer != '' && _vm.data.Issuer != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("签发人   ： ")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v("  " + _vm._s(_vm.data.Issuer))])]) : _vm._e(), _vm._v(" "), (_vm.data.IssueDate != '' && _vm.data.IssueDate != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("签发日期 ：")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v(" " + _vm._s(_vm.data.IssueDate))])]) : _vm._e()]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seachShow),
      expression: "seachShow"
    }],
    staticStyle: {
      "widht": "20px",
      "height": "1800px",
      "background-color": "#E6F0F2"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n  "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.ceprei.com/assets/img/logo1-default.png",
      "alt": "Logo"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "background-color": "#DCDCDC",
      "padding-top": "3px",
      "padding-bottom": "1px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "background-color": "#E6F0F2"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "font-size": "250%",
      "font-weight": "bold",
      "margin-top": "10px"
    }
  }, [_vm._v("证书报告验证中心")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "15px",
      "color": "#97a8be"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/"
    }
  }, [_vm._v("首页")]), _vm._v(" / 证书报告验证中心 ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "z-index": "999",
      "width": "100%",
      "background-color": "#3e4753",
      "color": "rgb(218, 213, 213)",
      "font-size": "14px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#E6F0F2"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://guangzhou.cyberpolice.cn/netalarm/netalarm/Welcome.jsp?bano=4401060100873",
      "data-v-4d3159fe": "",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://ca.ceprei.com/_nuxt/img/cyberpolice.bfb5ba4.gif",
      "border": "0",
      "data-v-4d3159fe": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "padding-top": "10px",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://ca.ceprei.com/_nuxt/img/logo2-default.73cb0f3.png"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("Copyright © 2015. 中国赛宝实验室 All rights reserved.  "), _c('i', {
    staticClass: "icon-home"
  }), _vm._v(" 广州市增城区朱村街朱村大道西78号  粤ICP备09030372号")]), _vm._v(" "), _c('p', [_vm._v("网站维护：020-87237193 业务联系：020-87236881")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-242e62f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/consignation/certificateAuthenticity.vue
// module id = 1194
// module chunks = 10